import { GridAction } from '@eforall/dashboard';
import { Donor } from '@interfaces';


export function getActions() {

	const actions: GridAction<Donor>[] = [
	];

	return actions;
}